module.exports = __webpack_public_path__ + "media/reskin-images/img--ald-direct-295bffae.png";